import { TRAINING_ACTION as ACTION_TYPE } from '../types/actionTypes';
import { getPropertyFromPayload } from '../lib';
const getActionTypeKey = actionType => {
  switch (actionType) {
    case ACTION_TYPE.SET_TRAINING_STATUS:
      {
        return 'trainingStep';
      }
    case ACTION_TYPE.SET_UNSAVED_KEYWORDS:
      {
        return 'unsavedKeywords';
      }
    case ACTION_TYPE.SET_GENERATED_KEYWORDS:
      {
        return 'generatedKeywords';
      }
    case ACTION_TYPE.SET_SHOW_TRAINING_SCREEN:
      {
        return 'showTrainingScreen';
      }
    case ACTION_TYPE.SET_SUMMARY_COUNTS:
      {
        return 'summaryCounts';
      }
    case ACTION_TYPE.SET_TRAINING_COMPLETE:
      {
        return 'trainingComplete';
      }
    case ACTION_TYPE.SET_TRAINING_ERROR:
      {
        return 'trainingError';
      }
    case ACTION_TYPE.SET_SHOULD_REFETCH_ON_OPEN:
      {
        return 'shouldRefetchOnOpen';
      }
    case ACTION_TYPE.SET_SHOW_TRAINING_ERROR_TOAST:
      {
        return 'showTrainingErrorToast';
      }
    case ACTION_TYPE.SET_MULTIPLE:
      {
        return 'multiple';
      }
  }
  return '';
};
const reducer = (state, action) => {
  const {
    type,
    payload
  } = action;
  const k = getActionTypeKey(type);
  switch (k) {
    case 'multiple':
      {
        return Object.assign(Object.assign({}, state), payload);
      }
    case '':
      {
        throw new Error(`Unknown action: ${type}`);
      }
    default:
      {
        if (getPropertyFromPayload(k, payload) === undefined) {
          break;
        }
        return Object.assign(Object.assign({}, state), {
          [k]: getPropertyFromPayload(k, payload)
        });
      }
  }
  throw new Error('Error with payload provided');
};
export default reducer;